import { PentestScanLight } from './pentest-scan-light';
import { PentestSeverityStatistics } from './pentest-severity-statistics';

export interface CustomerPentestStatistics {
  pentestScan: PentestScanLight;
  statistics: PentestSeverityStatistics;
}

export namespace CustomerPentestStatistics {
  export function mapFromApiValue(customerPentestStatistics: any): CustomerPentestStatistics {
    return { ...customerPentestStatistics };
  }
}
